const fetchApi = async (path, options = {}) => {
  try {
    const response = await fetch(path, {
      headers: { "Content-Type": "application/json", ...options.headers },
      ...options,
    });
    const data = await response.json();
    if (!response.ok) {
      return Promise.reject(data);
    }
    return data;
  } catch (error) {
    // Handle network errors and rejections from the above if condition
    throw new Error(error.message || "Network error");
  }
};

export default fetchApi;
